<template>
  <el-dialog
    class="stationeryRecord-edit"
    title="修改申请信息"
    :visible="dialogFormVisible"
    width="850px"
    center
    :close-on-click-modal="false"
    @open="dialogOpen"
    @close="dialogClose"
  >
    <div class="edit">
      <el-descriptions
        class="margin-top"
        title=""
        :column="2"
        border
        direction="horizontal"
        v-for="(item, index) in recordData"
        :key="index"
      >
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            选择文具
          </template>
          <el-select
            v-model="item.stationeryName"
            placeholder="请选择"
            filterable 
            @change="selectChange(item, $event)"
          >
            <el-option
              v-for="stationeryItem in stationeryList"
              :key="stationeryItem.id"
              :label="stationeryItem.itemName"
              :value="stationeryItem.id"
            >
            </el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-menu"></i>
            借用数量
          </template>
          <el-input
            v-model.quantity="item.quantity"
            placeholder="请输入"
            prop="rank"
            type="number"
            :min="1"
          ></el-input>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="success" @click="addRecord">添加一行</el-button>
      <el-button type="danger" @click="delRecord">删除一行</el-button>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" @click="confirm">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "",
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
    },
    stationeryRecordData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    stationeryList: {
      type: Array,
    },
  },
  data() {
    return {
      recordData: [],
    };
  },
  methods: {
    addRecord() {
      this.recordData.push({
        stationeryName: "",
        quantity: "",
      });
    },
    delRecord() {
      if (this.recordData.length == 1)
        return this.$message.warning("至少存在一条数据！");
      this.recordData.pop();
    },
    selectChange(item, e) {
      item.stationeryId = e;
    },
    dialogOpen() {
      // console.log(this.stationeryRecordData);
      this.recordData = this.stationeryRecordData.goodsList;
    },
    dialogClose() {
      this.$emit("update:dialogFormVisible", false);
    },
    confirm() {
      let { id } = this.stationeryRecordData;
      let data = {
        id,
        goodsList: this.recordData,
      };
      this.put(this.$url.updateStationeryRecord, data).then((res) => {
        // console.log("修改返回==>", res);
        if (res.code !== 200) return this.$message.error(res.msg);
        this.$message.success(res.msg);
        // 刷新列表
        this.$emit("edit", id);
        // 关闭弹出框
        this.dialogClose();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./stationeryRecordEdit.scss";
</style>